import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import './addNewPage.css';
import {
  createPage,
  setIsActive,
  setLayoutToActivePage,
} from './../../../../redux/actions/entities/pages';
import {
  convertObjectToArray,
  orderBy,
} from './../../../../redux/helpers';
import { store } from '../../../..';
import { generateWeddingTexts } from '../../../../redux/helpers/texts';
import { setGeneratedTextToCorrectPosition, generateButtonTexts } from '../../../../helpers/weddingHelper';
import { addPageToViewed } from '../../../../redux/actions/ui/addPageToViewed';


class AddNewPage extends Component {
  constructor(props) {
    super(props);
    this.insertNewPage = debounce(this.insertNewPage, 200);
    this.state = {
      addNewPage: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      layoutsById,
      pages,
      isChange,
      dispatch,
    } = this.props;

    const { pages: thisPages } = prevProps;

    if (isChange === this.props.isChange) {
      if (thisPages.length !== pages.length) {
        const [pageId] = pages.slice(-1);

        if (this.state.addNewPage) {
          dispatch(setIsActive(pageId));
        }
        // Load all layout
        const layoutsArray = convertObjectToArray(layoutsById).filter(layout => !layout.isCover && !layout.isBackFlyleaf && !layout.isFrontFlyleaf);
        if (this.state.addNewPage) {
          if (thisPages.length < pages.length) {
            this.setState({
              addNewPage: false,
            }, () => {
              const ordered = orderBy(layoutsArray, 'order');
              const [layoutId] = ordered.slice(0);
              dispatch(setLayoutToActivePage(layoutId.id, pageId, false, false));
              this.generatePageDefaultText(pageId);
            });
          }
        }
      }
    }
  }

  getArrayProperty = (array, property) => Object.values(array).find(element => element[property]);

  insertNewPage() {
    setTimeout(() => {
      this.props.dispatch(createPage(this.page));
      this.setState({
        addNewPage: true,
      });
    }, 0);


    this.setState({
      addNewPage: true,
    });
  }

  generatePageDefaultText = async (pageId) => {
    const { defaultText, layoutsById, texts } = this.props;
    const bgs = layoutsById[10].backgroundPlaceholder;
    const lastText = Object.values(texts).slice(-1)[0];
    for (const key in bgs) {
      if (key in bgs) {
        const text = {
          text: defaultText,
          font: lastText.font,
          color: lastText.color,
          fontSize: lastText.fontSize,
        };
        if (defaultText !== '') {
          await generateWeddingTexts(store, text, pageId);
          setGeneratedTextToCorrectPosition(store);
          this.props.dispatch(addPageToViewed(pageId));
        }
      }
    }
  }

  render() {
    const {
      pages,
      pageBackgroundColor,
      lang,
      maxSheets,
      pageBackgroundImage,
      type,
    } = this.props;

    const order = pages.length;
    this.page = {
      preview: '',
      layout: 0,
      placeholders: [],
      order,
      isActive: false,
      texts: [],
      backgroundColor: pageBackgroundImage !== '' ? null : pageBackgroundColor,
      backgroundImages: this.props.pagesById[this.props.pages[this.props.pages.length - 1]].backgroundImages,
    };

    return (
      <div>
        <div className={`add-page ${pages.length === maxSheets ? 'not-allowed' : ''}`}>
          <button className="green-btn" onClick={() => this.insertNewPage()}>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4.5,8.5h-4v4h-1v-4h-4v-1h4v-4h1v4h4Z" />
            </svg>
            { generateButtonTexts(type, lang).addNew }
          </button>
        </div>
      </div>
    );
  }
}

AddNewPage.defaultProps = {
  pageBackgroundColor: '',
  pageBackgroundImage: '',
  isChange: false,
  layoutsById: {},
  pages: [],
  maxSheets: 0,
  lang: {},
  dispatch: () => {},
  pagesById: {},
  defaultText: '',
};

AddNewPage.propTypes = {
  pageBackgroundColor: PropTypes.string,
  pageBackgroundImage: PropTypes.string,
  isChange: PropTypes.bool,
  layoutsById: PropTypes.object,
  pages: PropTypes.array,
  maxSheets: PropTypes.number,
  lang: PropTypes.object,
  dispatch: PropTypes.func,
  pagesById: PropTypes.object,
  defaultText: PropTypes.string,
};

export default connect(state => ({
  layouts: state.entities.layouts.allIds,
  layoutsById: state.entities.layouts.byId,
  texts: state.entities.texts,
  defaultText: state.bookProperties.defaultText,
}))(AddNewPage);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/add-new-page/addNewPage.jsx